<template>
  <section>
    <p>充值记录</p>
    <p>充值单号：{{fee.idView}}</p>
    <p>创建时间：{{fee.createAt | dt}}</p>
    <p>来自微信：{{fee.fromWechat}}</p>
    <p>来自支付宝：{{fee.fromAlipay}}</p>
    <p>来自现金：{{fee.fromCash}}</p>
    <p>赠送金额：{{fee.giftAccount}}</p>
  </section>
</template>

<script>
export default {
  props: ['fee'],
  computed: {
    total() {
      let t = 0
      this.ticket.clotheRecords.map((val, index) => {
        t += val.price
      })
      return t
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/prints/FeePrint.vue